
import XHeader from 'vux/src/components/x-header/index.vue'
import Toast from 'vux/src/components/toast/index.vue'

import {mapState,mapMutations} from 'vuex'
import { deliveryRecord } from '../service/getdata'
export default{
components:{
XHeader,
Toast
},
data(){
return{
msg: "",
show: false,
type: 1,
trade_type: ""
}
},
computed:{
...mapState(['token'])
},
created(){
this.trade_type = this.$route.query.trade_type
this.SETTOKEN()
this.getData()
},
methods:{
...mapMutations(['SETTOKEN']),
getData(){
var that = this
this.$Loading()
deliveryRecord({token: this.token, trade_type: this.trade_type}).then(function(res){
var res = res.data;
that.$Loading.close()
if(res.status=='1'){
that.info = res.data[0]
console.log(that.info)
}else if(res.status=='-1'){
that.$router.push('/pages/relogin')
}
}.bind(this),function(){
that.$Loading.close()
console.log("error")
})
},
sendMsg(content) {
this.msg = content;
this.show = true;
},


},
watch:{

}
}



// WEBPACK FOOTER //
// ./src/pages/deliveryContractHistory.vue